import React, { useState } from "react";
import CustomFieldModal from "./CustomFieldModal";
import EditCustomFieldModal from "./EditCustomFieldModal";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import useCustomField from "../../../../../hooks/useCustomField/UseCustomField";
import useUpdateCustomField from "../../../../../hooks/useCustomField/useUpdateCustomField";
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import useEditCustomField from "../../../../../hooks/useCustomField/useEditCustomField";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import FieldEditModal from "./FieldEditModal/FieldEditModal";
import ConfirmationPopup from "./Confirmation Popup/ConfirmationPopup";

const BuyerDetails = ({
  dynamicFields = [],
  hidden,
  onFieldChange,
  require,
  data,
  setData,
  Message
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [fieldToDelete, setFieldToDelete] = useState(null);
  const [division, setDivision] = useState("");
  const [message, setMessage] = useState({ type: "", text: "" });

  const { submitCustomField } = useCustomField();
  const { updateCustomField } = useUpdateCustomField();
  const apiUrls = process.env.REACT_APP_API_URLS;

  const {
    showEditModal,
    selectedField,
    handleOpenEditModal,
    handleCloseEditModal,
    handleSubmitUpdateField,
  } = useEditCustomField();

  const handleSubmit = async (data) => {
    const result = await submitCustomField(data);

    if (result.success) {
      toast.success("Field is Added Succefully", {
        position: "top-right",
        autoClose: 600,
      });

      setShowModal(false);
      setTimeout(() => {
        window.location.reload();
      }, 700);
    } else {
      toast.error(result.message, {
        position: "top-right",
        autoClose: 1000,
      });
      setShowModal(false);
      // setMessage({ type: "error", text: result.message });
    }
  };

  const handleOpenModal = () => {
    setDivision("Buyer Details");
    setShowModal(true);
  };

  const handleDeleteField = (field) => {
    setFieldToDelete(field);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (fieldToDelete) {
      try {
        const response = await axios.delete(
          `${apiUrls}/buyer_settings/custom-fields/${fieldToDelete.id}/`
        );

        if (response.status === 204 || response.status === 200) {
          window.location.reload();
          setMessage({ type: "success", text: "Field deleted successfully!" });
        } else {
          setMessage({ type: "error", text: "Failed to delete the field." });
        }
      } catch (error) {
        setMessage({
          type: "error",
          text: "An error occurred while deleting the field.",
        });
      } finally {
        setShowDeleteModal(false);
        setFieldToDelete(null);
      }
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setFieldToDelete(null);
  };

  const handleInputChange = (e, field) => {
    const { value } = e.target;
    // Update the specific field in the data object
    setData((prevData) => ({
      ...prevData,
      [field.column_name]: value,
    }));
    onFieldChange(field.column_name, value);
  };

  const [isEditModalOpen, setEditModalOpen] = useState(false)
  const [formData, setFormData] = useState({
    label: '',
    placeholder: '',
    type: 'required',
  });

  const handleSave = () => {
    console.log("Form Data Saved:", formData);
    setEditModalOpen(false);
  };

  const [dropdownType, setDropdownType] = useState("")
  const [openStatusPopup, setOpenStatusPopup] = useState(false)
  const [statusMessage, setStatusMessage] = useState("")
  const [selectedStatus, setSelectedStatus] = useState("")

  const handleshowConfirmPopup = (opt) => {
    setOpenStatusPopup(true)
    setStatusMessage(opt)
  }

  return (
    <>
      <div className="border-2 border-gray-200 shadow-lg rounded-md p-6 mt-8">
        <h2 className="text-lg font-semibold mb-4">
          <span className="underline">Buyer Details :</span>
        </h2>

        {/* {message.text && (
          <div
            className={`p-2 mb-4 rounded-md ${
              message.field_type === "success"
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }`}
          >
            {message.text}
          </div>
        )} */}

        <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <div className="flex items-center justify-between">
              <label className="block">
                Email<span className="text-red-500">*</span>
              </label>
              {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => { setFormData({ label: "Email", placeholder: "Enter Your Email Address" });; setEditModalOpen(true) }} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <input
              type="email"
              value={data?.email || ""}
              placeholder="Enter your Email Address"
              className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
              onChange={(e) => handleInputChange(e, { column_name: "email" })}
              disabled={require}
              readOnly={require}
            />
          </div>

          <div>
            <div className="flex items-center justify-between">
              <label className="block">
                Mobile<span className="text-red-500">*</span>
              </label>
              {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => { setFormData({ label: "Mobile", placeholder: "Enter Mobile Number" });; setEditModalOpen(true) }} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <input
              type="text"
              value={data?.mobile || ""}
              placeholder="Enter Mobile Number"
              className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
              onChange={(e) => handleInputChange(e, { column_name: "mobile" })}
              disabled={require}
              readOnly={require}
            />
          </div>

          <div>
            <div className="flex items-center justify-between">
              <label htmlFor="buyerstatus" className="block">
                Buyer Status<span className="text-red-500">*</span>
              </label>
              {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => { setFormData({ label: "Buyer Status", placeholder: "select your buyer status" });; setEditModalOpen(true) }} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <select
              id="buyerstatus"
              value={data?.buyerstatus || selectedStatus}
              name="buyerstatus" // Add a name for the field
              className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
              onChange={(e) => { handleshowConfirmPopup(e.target.value); setDropdownType("buyer status") }}
              disabled={require}
              readOnly={require}
            >
              <option>Select your buyer status</option>
              <option value="Active">Active</option>
              <option value="On Hold">On Hold</option>
              <option value="Premium">Premium</option>
              <option value="Deactive">Deactive</option>
            </select>
          </div>

          <div>
            <div className="flex items-center justify-between">
              <label htmlFor="presentsubcription" className="block">
                Present Subscription<span className="text-red-500">*</span>
              </label>
              {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => { setFormData({ label: "Present Subscription", placeholder: "Select Present Subscription" });; setEditModalOpen(true) }} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <select
              id="presentsubcription"
              value={data?.presentsubcription || selectedStatus}
              name="presentsubcription" // Add a name for the field
              className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
              onChange={(e) => { handleshowConfirmPopup(e.target.value); setDropdownType("present subscription") }}
              disabled={require}
              readOnly={require}
            >
              <option>Select Present Subscription</option>
              <option value="Per Per Contact">Per Per Contact</option>
              <option value="Monthly 50">Monthly 50</option>
              <option value="Yearly 500">Yearly 500</option>
            </select>
          </div>
        </form>

        {dynamicFields.length > 0 && (
          <div className="mt-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-3">
              {dynamicFields.map(
                (field, index) =>
                  field.division == "Buyer Details" && (
                    <div key={field?.column_name || index}>
                      <div className="flex justify-between">
                        <label className="block">
                          {field?.field_label
                            ? field.field_label.replace(/_/g, " ")
                            : "Unlabeled Field"}
                          {field?.is_required && (
                            <span className="text-red-500">*</span>
                          )}
                        </label>
                        <div
                          className={`gap-[5px] ${hidden ? "hidden" : "flex"}`}
                        >
                          <button
                            className="color-[#979797]"
                            onClick={() => handleOpenEditModal(field)}
                          >
                            <MdOutlineEdit className="color-[#979797]" />
                          </button>
                          <button
                            className="color-[#979797]"
                            onClick={() => handleDeleteField(field)}
                          >
                            <MdDeleteOutline className="color-[#979797]" />
                          </button>
                        </div>
                      </div>

                      {field?.field_type === "text" ||
                        field?.field_type === "date" ? (
                        <input
                          value={data?.[field.column_name] || ""}
                          type={field.field_type}
                          placeholder={field?.placeholder || ""}
                          className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
                          onChange={(e) => handleInputChange(e, field)}
                          disabled={require}
                          readOnly={require}
                        />
                      ) : field?.field_type === "radio" ||
                        field?.field_type === "checkbox" ? (
                        field?.options?.split(",").map((option) => (
                          <div
                            key={option}
                            className="flex items-center space-x-2 mt-1"
                          >
                            <input
                              value={data?.[field.column_name] || { option }}
                              type={field.field_type}
                              id={option}
                              name={field.column_name}
                              // value={option}
                              onChange={(e) => handleInputChange(e, field)}
                              disabled={require}
                              readOnly={require}
                            />
                            <label htmlFor={option}>{option}</label>
                          </div>
                        ))
                      ) : field?.field_type === "dropdown" ? (
                        <select
                          className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none"
                          onChange={(e) => handleInputChange(e, field)}
                          disabled={require}
                          readOnly={require}
                        >
                          <option>Select {field?.column_name}</option>
                          {field?.options?.split(",").map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      ) : null}
                    </div>
                  )
              )}
            </div>
          </div>
        )}

        <div className='grid grid-cols-2 items-center px-10 mt-6'>
          <div className='flex items-center justify-end'>
            <button
              onClick={handleOpenModal}
              className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
            >
              Add Field
            </button>
          </div>
          <div className='flex items-center justify-end'>
            <button
              onClick={handleOpenModal}
              className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
            >
              Add Field
            </button>
          </div>
        </div>
      </div>


      <FieldEditModal
        isOpen={isEditModalOpen}
        onClose={() => setEditModalOpen(false)}
        onSave={handleSave}
        formData={formData}
        setFormData={setFormData}
        content={"Buyer Details"}
      />

      {openStatusPopup && <ConfirmationPopup
        message={`Are you sure you want to change the "${dropdownType}" to "${statusMessage}"?`}
        onCancel={() => { setOpenStatusPopup(false); setSelectedStatus("Select"); }}
        onConfirm={() => {
          setSelectedStatus(statusMessage);
          setOpenStatusPopup(false);
        }} />}

      <CustomFieldModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={handleSubmit}
        division={division}
      />

      <EditCustomFieldModal
        isOpen={showEditModal}
        onClose={handleCloseEditModal}
        onSubmit={handleSubmitUpdateField}
        fieldData={selectedField}
      />

      <DeleteConfirmationModal
        isOpen={showDeleteModal}
        onClose={handleCloseDeleteModal}
        onConfirm={handleConfirmDelete}
      />
      <ToastContainer />
    </>
  );
};

export default BuyerDetails;
